import script from "./InvestPreviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestPreviewModal.vue?vue&type=script&setup=true&lang=ts"

export default script